import { Avatars } from "@/features/auth/utils/avatars";
import { Avatar, Box, Flex, Heading, Spinner } from "@radix-ui/themes";
import { FC } from "react";

export const SettingsProfileAvatars: FC<{
  handleInput: any;
  setIsAvatar: any;
}> = ({ handleInput, setIsAvatar }) => {
  return (
    <Flex gap="3" wrap="wrap" direction="column">
      {Avatars.map((item) => {
        return (
          <Box key={`${item.category}`}>
            <Heading as="h2" size="3">
              {item.category}
            </Heading>
            <Flex gap="3" wrap="wrap">
              {item.values.map((avt) => {
                return (
                  <Box
                    key={`${avt.img}`}
                    onClick={() => {
                      handleInput(avt.img);
                      setIsAvatar(true);
                    }}
                  >
                    <Avatar src={avt.img} fallback="A" radius="full" size="5" />
                  </Box>
                );
              })}
            </Flex>
          </Box>
        );
      })}
    </Flex>
  );
};
